import { MessageWithAttachmentsDtoQuestionType } from '../services/api.clients.generated';

/**
 * Display colors for the message question types (categories).
 *
 * The category values are a fixed backend enum ({@link MessageWithAttachmentsDtoQuestionType}),
 * so the palette is maintained here on the frontend. Any value missing from the map
 * (e.g. a future enum member) falls back to {@link DEFAULT_QUESTION_TYPE_COLOR}.
 */
const QUESTION_TYPE_COLORS: Readonly<Record<MessageWithAttachmentsDtoQuestionType, string>> = {
  [MessageWithAttachmentsDtoQuestionType.MY_ACCOUNT]: '#6c5ce7',
  [MessageWithAttachmentsDtoQuestionType.GENERAL_QUESTION]: '#0984e3',
  [MessageWithAttachmentsDtoQuestionType.CLAIM]: '#e17055',
  [MessageWithAttachmentsDtoQuestionType.PREVENTION]: '#00b894',
  [MessageWithAttachmentsDtoQuestionType.ESTIMATION]: '#fdcb6e',
  [MessageWithAttachmentsDtoQuestionType.BUILDINGS]: '#0a8276',
  [MessageWithAttachmentsDtoQuestionType.SINISTRE]: '#d63031',
  [MessageWithAttachmentsDtoQuestionType.SUBSIDIES]: '#e84393'
};

export const DEFAULT_QUESTION_TYPE_COLOR = '#94a3b8';

export function getQuestionTypeColor(questionType: string | null | undefined): string {
  if (!questionType) {
    return DEFAULT_QUESTION_TYPE_COLOR;
  }

  return QUESTION_TYPE_COLORS[questionType as MessageWithAttachmentsDtoQuestionType] ?? DEFAULT_QUESTION_TYPE_COLOR;
}
